import { render } from "./MasterDataExport.vue?vue&type=template&id=67fc8b5a"
import script from "./MasterDataExport.vue?vue&type=script&lang=ts"
export * from "./MasterDataExport.vue?vue&type=script&lang=ts"
script.render = render

export default script